export default __webpack_public_path__ + "static/media/website_shared.386f6d64.svg";